import React from "react";
import { Grid } from "@material-ui/core";
import { IoTicket } from "react-icons/io5";
import ButtonCustom from "../../../features/ButtonCustom/ButtonCustom";
import { Assort } from "../../models/Assort";
import { BasketItem } from "../../models/BasketItem";
import getId from "../../../utils/getId";
import TooltipCustom from "../../../features/TooltipCustom";
import { IconButton } from "@mui/material";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useLocation } from "react-router";
import { PASS_PAGE } from "../../routes";

interface IProps {
  colorClass: string;
  ticket: Assort;
  onAddToBasket: (value: Assort) => void;
  onRemoveToBasket: (index: number) => void;
  basket: BasketItem[];
  isSaleWithExercise: boolean;
}

const Ticket: React.FC<IProps> = ({
  colorClass,
  ticket,
  onAddToBasket,
  onRemoveToBasket,
  basket,
  isSaleWithExercise
}: IProps) => {
  const isDesktop = useDesktopSize();
  const location = useLocation();
  const page = location.pathname;
  const getQnt = (): number => {
    const itemBasket = basket.find((item: BasketItem) => item.assortIds === getId(ticket));
    return itemBasket ? itemBasket.qnt : 0;
  };

  const getIndexBasket = (): number => {
    return basket.findIndex((item: BasketItem) => item.assortIds === getId(ticket));
  };

  const ticketClass =
    getQnt() > 0 ? (isSaleWithExercise ? "ticket-color-second" : "ticket-color-first") : "ticket-color-default";

  const disabledMinusBtn = getQnt() > 0;
  const textTooltip =
    isSaleWithExercise || page === PASS_PAGE
      ? "Park Atrakcji, Wesołe Miasteczko i Park Wodny"
      : "Park Atrakcji i Wesołe Miasteczko";

  return (
    <Grid
      container
      spacing={1}
      className={`ticket ${ticketClass}`}
      justifyContent={"space-around"}
      alignContent={"center"}
      alignItems={"center"}
    >
      <Grid item xs={2} md={1}>
        <TooltipCustom text={textTooltip} placement={"top"}>
          <IconButton style={{ padding: 0 }}>
            <IoTicket className={`io-ticket ${colorClass}`} size={24} />
          </IconButton>
        </TooltipCustom>
      </Grid>
      <Grid item xs={6} md={7} className={!isDesktop ? "ticketNameAndInfoMobile" : ""}>
        <p>{ticket.displayWebName}</p>

        {ticket.description && (
          <TooltipCustom text={ticket.description} placement={isDesktop ? "right" : "top"}>
            <IconButton style={{ marginLeft: 5, padding: 0 }}>
              <AiOutlineQuestionCircle className={`bs-check-circle color-textColorOpacity60`} />
            </IconButton>
          </TooltipCustom>
        )}
      </Grid>
      <Grid item xs={4} md={2}>
        <p className={"ticket-price"}>{`${ticket.price.toFixed(2)} zł`}</p>
      </Grid>
      <Grid item xs={6} md={2} className={"ticket-btn"}>
        <ButtonCustom
          title={"-"}
          className={`button-add ${disabledMinusBtn ? "" : "disabled"}`}
          onClick={() => onRemoveToBasket(getIndexBasket())}
          disabled={!disabledMinusBtn}
        />
        <p>{getQnt()}</p>
        <ButtonCustom title={"+"} className={`button-add`} onClick={() => onAddToBasket(ticket)} />
      </Grid>
    </Grid>
  );
};

export default Ticket;
